// ##############################
// // // Constants
// #############################

// Redirecting route using domain, email and user Id
export const getRouteScreenPlayerUniverse = (domain, email, uid) =>
	`https://${domain}.visualid.com/admin/?e=${email}&id=${uid}`;

// Redirect to Admin User Details Page
export const getRouteAdminUserDetails = (domain, userId) =>
	`https://${domain}.visualid.com/admin/users/details/?id=${userId}`;

export const PLAYER_TYPE_OPTIONS = [
	{ value: 'ANDROID_EXTERNAL', label: 'Android External Player' },
	{ value: 'ANDROID_ONSCREEN', label: 'Android On-Screen' },
	{ value: 'RETAIL_TILL', label: 'Retail Solutions Till' },
	{ value: 'STARTLE', label: 'Startle' },
	{ value: 'SCREENFUSION', label: 'ScreenFusion' },
];
